import Swiper from "../../../vendors/swiper.min";
import { Video } from "../video/video";

export default class SlidersClass {
	constructor(mainCont) {
		this.mainCont = document.querySelector(mainCont);
		this.swiperCont = document.querySelector(".swiper-container");

		// progressbar
		this.probar = document.querySelector(".top_slider__progress-bluebar");
		this.mask = document.querySelector(".top_slider__progress-mask");
		this.whiteText = document.querySelector(
			".top_slider__progress-whitetext-content"
		);
		this.blackText = document.querySelector(
			".top_slider__progress-blacktext-content"
		);
		this.widthPB = 0;
		this.firstStart = true;

		this.offersList = [];
		this.slidesBeginning = this.swiperCont.querySelectorAll(".swiper-slide");
		this.mySwiper;

		this.currSlide;
		this.currSlideIdx = "";
		this.slidesParams = [];

		//Pagination
		this.currPagination;
		this.prevPagination;

		// this.currSlideTime;
		this.interval;
		this.textTimeout;
		this.videoContainers = this.swiperCont.querySelectorAll("[data-type=video]");
		this.videoCtrlsArr = [];
		this.currentVideo;
		// this.videoCtrls = new videoControls(this.videoContainer);
	}

	initAll() {
		this.mainCont.classList.add("show-me");

		[].forEach.call(this.slidesBeginning, (slide) => {
			const videoEl = slide.querySelector("[data-swiper-video]");
			let videoCls = null;

			if (videoEl && !isMobile) {
				videoCls = new Video(videoEl);
			}
			// get slides params
			this.slidesParams.push({
				textDelay: parseInt(slide.getAttribute("data-textDelayTime")),
				duration: parseInt(slide.getAttribute("data-swiper-autoplay")),
				delayTime: parseInt(slide.getAttribute("data-delayTime")),
				videoDomEl: videoEl,
				videoClsEl: videoCls,
			});

			// pause videos
		});

		// for (let i = 0; i < this.videoContainers.length; i++) {
		//     const videoContainer = this.videoContainers[i]
		//     videoContainer.setAttribute('data-video-key', i)
		//     const videoCtrl = new videoControls(videoContainer)
		//     this.videoCtrlsArr.push(videoCtrl)
		// }

		this.offerList();
		this.mySwiper = new Swiper(this.swiperCont, {
			slidesPerView: 1,
			spaceBetween: 30,
			speed: 300,
			autoplay: {
				disableOnInteraction: true,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				bulletActiveClass: "swiper-pagination-bullet-active",
				renderBullet: (index, className) => {
					className += " swiper-pagination-bullet";
					return (
						'<span class="' +
						className +
						'">' +
						this.offersList[index] +
						'<span class="sr-only">(aktywny)</span></span>'
					);
				},
			},
			a11y: {
				paginationBulletMessage: "Przejdź do slajdu {{index}}",
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
		});
		this.createProgressBar();
		this.mySwiper.autoplay.start();

		this.currSlide = this.swiperCont.querySelector(".swiper-slide-active");
		this.currSlideIdx = parseInt(this.mySwiper.activeIndex);
		// this.currSlideTime = parseInt(this.currSlide.getAttribute('data-swiper-autoplay'));

		this.intervalSet(true);
		this.assignButtons();

		// this.videoCtrls.assignBtns();
		// this.setPlayPauseBtnAcive('play')

		this.addAriaAttr();

		this.mySwiper.on("init", () => {});

		this.mySwiper.on("transitionStart", () => {
			// clearInterval(this.interval);

			if (this.swiperCont.querySelector(".top_slider__text.show-me"))
				this.swiperCont
					.querySelector(".top_slider__text.show-me")
					.classList.remove("show-me");

			this.stopVideo(this.currSlideIdx);

			this.currSlide = this.swiperCont.querySelector(".swiper-slide-active");
			this.currSlideIdx = parseInt(this.mySwiper.activeIndex);

			this.slideTabIndexes();
			this.startVideo(this.currSlideIdx);

			this.intervalSet();
		});

		this.mySwiper.on("slideChangeTransitionEnd", () => {
			this.currPagination = this.mySwiper.pagination.bullets[this.currSlideIdx];
			this.currPagination.setAttribute("aria-selected", true);
			for (let i = 0; i < this.slidesBeginning.length; i++) {
				let bullet = this.mySwiper.pagination.bullets[i];
				bullet.setAttribute("role", "tab");
			}
		});

		this.mySwiper.on("slideChange", () => {
			this.prevPagination = this.mySwiper.pagination.bullets[this.currSlideIdx];
			this.prevPagination.setAttribute("aria-selected", false);
			if (this.currSlideIdx === this.mySwiper.pagination.bullets.length - 1) {
				this.pagin = this.mySwiper.pagination.bullets[0];
				this.pagin.setAttribute("role", "alert");
			} else {
				this.pagin = this.mySwiper.pagination.bullets[this.currSlideIdx + 1];
				this.pagin.setAttribute("role", "alert");
			}
		});
	}

	addAriaAttr() {
		for (let i = 0; i < this.slidesBeginning.length; i++) {
			let bullet = this.mySwiper.pagination.bullets[i];
			bullet.setAttribute("aria-selected", i === 0 ? "true" : "false");
			bullet.setAttribute("role", "tab");
			bullet.setAttribute("role", i === 0 ? "alert" : "");
		}
	}

	offerList() {
		for (let i = 0; i < this.slidesBeginning.length; i++) {
			this.offersList.push(this.slidesBeginning[i].getAttribute("data-name"));
		}
	}

	createProgressBar() {
		for (let i = 0; i < this.offersList.length; i++) {
			let text1 = document.createTextNode(this.offersList[i]);
			let text2 = document.createTextNode(this.offersList[i]);
			let serviceNamePlace1 = document.createElement("span");
			let serviceNamePlace2 = document.createElement("span");
			serviceNamePlace1.appendChild(text1);
			serviceNamePlace2.appendChild(text2);
			this.whiteText.appendChild(serviceNamePlace1);
			this.blackText.appendChild(serviceNamePlace2);
		}
	}

	assignButtons() {
		const btnPlay = this.mainCont.querySelector("[data-wcag-swiperPlay]");
		const btnPause = this.mainCont.querySelector("[data-wcag-swiperPause]");
		const btnRep = this.mainCont.querySelector("[data-wcag-swiperReplay]");

		if (btnPlay)
			btnPlay.addEventListener("click", (e) => {
				e.stopPropagation();
				this.mySwiper.autoplay.start();
				this.intervalSet();
				btnPlay.style.display = "none";
				if (btnPause) {
					btnPause.style.display = "block";
					btnPause.focus();
				}
				// this.setPlayPauseBtnAcive("play");
			});
		if (btnPause)
			btnPause.addEventListener("click", (e) => {
				e.stopPropagation();
				this.mySwiper.autoplay.stop();
				btnPause.style.display = "none";
				if (btnPlay) {
					btnPlay.style.display = "block";
					btnPlay.focus();
				}
				clearInterval(this.interval);
				// this.setPlayPauseBtnAcive("pause");
			});
		if (btnRep)
			btnRep.addEventListener("click", () => {
				// this.probar.style.width = '3%';
				// this.mask.style.width = '3%';
				// clearInterval(this.interval);
				this.mySwiper.slideTo(0);
				this.mySwiper.autoplay.start();
				this.intervalSet(true);
			});
	}

	slideTabIndexes() {
		const slides = this.swiperCont.querySelectorAll(".swiper-slide");
		// const btn = this.currSlide.querySelector('.slide-button');

		[].forEach.call(slides, (slide) => {
			const allBtns = slide.querySelectorAll("button, a");
			if (slide.classList.contains("swiper-slide-active")) {
				[].forEach.call(allBtns, (btn) => {
					btn.setAttribute("tabIndex", 0);
				});
			} else {
				[].forEach.call(allBtns, (btn) => {
					btn.setAttribute("tabIndex", -1);
				});
			}
		});
	}

	intervalSet(firstStart) {
		const duration =
			this.slidesParams[this.currSlideIdx].duration -
			this.slidesParams[this.currSlideIdx].delayTime;
		const time = duration / (1000 / this.slidesBeginning.length);
		const actualWidth =
			this.currSlideIdx * (100 / this.slidesBeginning.length) +
			100 / this.slidesBeginning.length;

		const radiusAnimTime = duration * 0.0002 + "s";
		this.probar.style.animationDuration = radiusAnimTime;

		if (firstStart) {
			this.widthPB = 1.7;
		} else {
			this.widthPB = this.currSlideIdx * (100 / this.slidesBeginning.length);
		}

		if (this.interval) clearInterval(this.interval);
		if (this.textTimeout) clearTimeout(this.textTimeout);

		this.textTimeout = setTimeout(() => {
			this.currSlide.querySelector(".top_slider__text").classList.add("show-me");
			// console.log('now show me text', this.currSlideIdx);
		}, this.slidesParams[this.currSlideIdx].textDelay);

		this.interval = setInterval(() => {
			if (this.widthPB <= actualWidth) {
				this.probar.style.width = this.widthPB + "%";
				this.mask.style.width = this.widthPB + "%";

				let widthBar = parseInt(this.probar.style.width);
				if (
					widthBar >= actualWidth - 2 &&
					!this.probar.classList.contains("no-radius")
				) {
					this.probar.classList.add("no-radius");
				}
				if (
					widthBar < actualWidth - 2 &&
					this.probar.classList.contains("no-radius")
				) {
					this.probar.classList.remove("no-radius");
				}
				this.widthPB += 0.1;
			}
			// console.log(this.widthPB)
		}, time);
	}

	stopVideo(slideIdx) {
		const vidCls = this.slidesParams[slideIdx].videoClsEl;

		if (vidCls) {
			vidCls.stopVideo();
		}
	}

	startVideo(slideIdx) {
		const vidCls = this.slidesParams[slideIdx].videoClsEl;
		const vidEl = this.slidesParams[slideIdx].videoDomEl;

		//console.log(vidCls, vidEl)
		if (vidCls && vidEl.hasAttribute("data-autoplay")) {
			vidCls.playVideo();
		}

		// if (this.currentVideo) {
		//     this.currentVideo.pauseVid();
		//     this.currentVideo = null;
		// }
		// const isVideo = slide.getAttribute('data-type') === 'video' ? true : false
		// if (isVideo) {
		//     const videoKey = slide.getAttribute('data-video-key')
		//     this.videoCtrlsArr[videoKey].assignBtns()
		//     this.currentVideo = this.videoCtrlsArr[videoKey]
		// }
	}

	// setPlayPauseBtnAcive(playPause) {
	//     if (playPause === 'play') {
	//         this.btnPlay.setAttribute('data-slider-btn', 'active')
	//         this.btnPause.removeAttribute('data-slider-btn')
	//     } else {
	//         this.btnPlay.removeAttribute('data-slider-btn')
	//         this.btnPause.setAttribute('data-slider-btn', 'active')
	//     }
	// }
}
